export enum PreloadReleaseMode {

    RELEASE_ON_PLAYER_READY = 0,
    RELEASE_ON_INITIAL_SEGMENTS_LOAD = 1

}